import {
  useNetworkSelection,
  useTokenSelection,
} from '../stores/token-selection/actions'
import { ModalModeProvider } from './modal-mode-context'
import SwapSection from './token-page/swap-section'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from './ui/dialog'

export const TradeModalDialog = ({
  isOpen,
  open,
  close,
}: {
  isOpen: boolean
  open: () => void
  close: () => void
}) => {
  const { isOpen: isTokenSelectionOpen, isAnimatedOpen } = useTokenSelection()
  const { isOpen: isNetworkSelectionOpen } = useNetworkSelection()

  const isSelectionFlowOpen =
    isTokenSelectionOpen || isNetworkSelectionOpen || isAnimatedOpen

  return (
    <Dialog
      open={isOpen}
      onOpenChange={(isOpen) => (isOpen ? open() : close())}
    >
      <DialogContent
        aria-describedby='trade modal'
        className='w-96 h-fit bg-background border border-border1 rounded-3xl focus:outline-none max-h-[calc(100vh-100px)]'
        closeAction={close}
        showCloseButton={!isSelectionFlowOpen}
        headerClassName='border-b border-border1'
        middle={<DialogTitle className='text-xl'>Trade</DialogTitle>}
        showBackButton={false}
      >
        <ModalModeProvider>
          <DialogDescription />
          <SwapSection />
        </ModalModeProvider>
      </DialogContent>
    </Dialog>
  )
}
